/* Gallery behaviour: masonry columns + product variant picker + mobile nav */
(function () {
  /* ---------- Masonry ---------- */
  function layoutGrid(grid) {
    var wrap = grid.querySelector('.g-cols');
    if (!wrap) return;
    if (!grid._items) grid._items = Array.prototype.slice.call(wrap.querySelectorAll('.g-item'));
    var desktop = window.matchMedia('(min-width: 750px)').matches;
    var cols = parseInt(desktop ? grid.dataset.cols : grid.dataset.colsMobile, 10) || 1;
    if (grid._cols === cols) return;
    grid._cols = cols;

    wrap.innerHTML = '';
    wrap.classList.add('is-masonry');
    var colEls = [];
    var heights = [];
    for (var c = 0; c < cols; c++) {
      var col = document.createElement('div');
      col.className = 'g-col';
      wrap.appendChild(col);
      colEls.push(col);
      heights.push(0);
    }
    var captionAllowance = grid.classList.contains('g-grid--below') ? 0.06 : 0;
    grid._items.forEach(function (item) {
      var shortest = heights.indexOf(Math.min.apply(null, heights));
      colEls[shortest].appendChild(item);
      heights[shortest] += (parseFloat(item.dataset.ratio) || 1) + captionAllowance + 0.05;
    });
  }

  function initGrids() {
    var grids = document.querySelectorAll('[data-g-grid]');
    grids.forEach(layoutGrid);
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { grids.forEach(layoutGrid); }, 150);
    });
  }

  /* ---------- Product variant picker ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-g-variants]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-g-price]');
    var btn = root.querySelector('[data-g-add]');
    var mainImg = document.querySelector('.g-main-img');

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-g-option]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var sel = selected();
      var v = data.variants.find(function (variant) {
        return variant.options.every(function (o, i) { return o === sel[i]; });
      });
      if (!v) {
        btn.disabled = true;
        btn.textContent = data.labels.unavailable;
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = v.price;
      btn.disabled = !v.available;
      btn.textContent = v.available ? data.labels.add : data.labels.soldOut;
      if (mainImg && v.image && data.media[v.image]) {
        mainImg.removeAttribute('srcset');
        mainImg.src = data.media[v.image];
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-g-option]')) update();
    });
  }

  /* ---------- Mobile nav ---------- */
  function initNav() {
    var nav = document.querySelector('.g-nav');
    var toggle = document.querySelector('.g-nav__toggle');
    if (!nav || !toggle) return;
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('g-nav--open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function init() {
    initGrids();
    document.querySelectorAll('[data-g-product]').forEach(initProduct);
    initNav();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();